import React from 'react';

import { stateHooks } from '@nxte-nl/state-hooks';

export const keyboardHooks = {
  useEscape(enabled: boolean, onEscape: () => void) {
    const {
      value: pressedOnce,
      setTrue: setPressedOnce,
    } = stateHooks.useBooleanState({ initialState: false });
    const onKeydown = React.useCallback(
      (event: KeyboardEvent) => {
        if (enabled && event.key === 'Escape') {
          onEscape();
        }
      },
      [enabled, onEscape],
    );

    React.useEffect(() => {
      if (enabled && !pressedOnce) {
        window.addEventListener('keyup', onKeydown);
        setPressedOnce();
      }

      return () => window.removeEventListener('keyup', onKeydown);
    }, [
      enabled,
      onEscape,
      onKeydown,
      pressedOnce,
      setPressedOnce,
    ]);

    return { onKeydown };
  },
};
